<nav class="navbar navbar-expand-lg" [ngClass]="{'affix': navIsAffix==true}">
    <button class="navbar-toggler ml-auto" type="button" data-toggle="collapse" data-target="#myNavbar"
    aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation"
    (click)="toggleNavbar()">
      <span class="navbar-toggler-icon"></span>
      <span class="navbar-toggler-icon"></span>
      <span class="navbar-toggler-icon"></span>
    </button>
        <a class="navbar-brand" routerLink="/home">
          <figure>
            <img src="../../../assets/logo.png" class="imgNormal" height=65 width=65>
            <img src="../../../assets/logobranco.png" class="imgAffix" height=80 width=80>
          </figure>
        </a>
      <div class="navbar-collapse collapse" id="myNavbar" [ngClass]="{ 'show': navbarOpen }">
        <div *ngIf="authService.user$ | async; then authenticated else guest"></div>
        <ng-template #authenticated>
          <ul class="navbar-nav ml-auto">
            <li><a routerLink="/dashboard"    routerLinkActive="active">DASHBOARD</a></li>
            <li><a routerLink="/adm-about" routerLinkActive="active">ABOUT</a></li>
            <li><a routerLink="/adm-services" routerLinkActive="active">SERVICES</a></li>
            <li><a routerLink="/adm-skills" routerLinkActive="active">SKILLS</a></li>
            <li><a routerLink="/adm-portfolio" routerLinkActive="active">PORTFOLIO</a></li>
            <li><a routerLink="/adm-messages" routerLinkActive="active">MESSAGES</a></li>
          </ul>
        </ng-template>
        <ng-template #guest>
          <ul class="navbar-nav ml-auto">  
            <li><a routerLink="/home"  routerLinkActive="active" (click)="toggleNavbar()" i18n="Nav Home|Label for Nav Home@@NavHome">HOME</a></li>
            <li><a routerLink="/about" routerLinkActive="active" (click)="toggleNavbar()" i18n="Nav About|Label for Nav About@@NavAbout">ABOUT ME</a></li>
            <li><a routerLink="/services" routerLinkActive="active" (click)="toggleNavbar()" i18n="Nav Services|Label for Nav Services@@NavServices">SERVICES</a></li>
            <!--<li><a href="#blog">BLOG</a></li>-->
            <li><a routerLink="/contact" routerLinkActive="active" (click)="toggleNavbar()" i18n="Nav Contact|Label for Nav Contact@@NavContact">CONTACT ME</a></li>
          </ul>
        </ng-template>
        
      </div>
      <div>
        <ul class="lang">
          <li><a href="{{hashLoc}}" target="_self" id="lang"> | {{locCode}} </a></li>
        </ul>
      </div>
  </nav>
